module.exports = __webpack_public_path__ + "static/media/slider1.6e6f0b9e.png";